import Vue from "vue";
import VueRouter from "vue-router";

// import Home from '../views/Home.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/by-pass/:key",
    name: "ByPass",
    component: () => import("../views/ByPass.vue"),
  },
  {
    path: "/page-authorization-not-found",
    name: "PageAuthorizationNotFound",
    component: () => import("../views/PageAuthorizationNotFound.vue"),
  },
  {
    path: "/oneid-login/:id",
    name: "OneidLoing",
    component: () => import("../views/OneidLoing.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Register.vue"),
  },
  {
    path: "/conference",
    name: "ConferenceDetail",
    component: () => import("../views/Conference.vue"),
  },
  {
    path: "/conference-telemed",
    name: "ConferenceTelemed",
    component: () => import("../views/telemed/ConfereceTelemed.vue"),
  },
  {
    path: "/TEST_page",
    name: "TEST_page",
    component: () => import("../views/TEST_page.vue"),
  },
  {
    path: "/new-conference",
    name: "NewConference",
    component: () => import("../views/conference/NewConference.vue"),
  },
  {
    path: "/cancel-conference",
    name: "CancelConference",
    component: () => import("../views/conference/CancelConference.vue"),
  },
  {
    path: "/create-conference",
    name: "CreateConference",
    component: () => import("../views/conference/CreateConference.vue"),
  },
  //  {
  //   path: "/conference-kasemrad",
  //   name: "ConfereceKasemrad",
  //   component: () => import("../views/telemed/ConfereceKasemrad.vue"),
  // },
  {
    path: "/dashboard",
    name: "",
    component: () => import("../views/Navbar.vue"),
    children: [
      {
        path: "/",
        name: "Dashboard",
        meta: { requiresAuth: true },
        component: () => import("../views/Dashboard.vue"),
      },
      {
        path: "/home-visit",
        name: "HomeVisit",
        component: () => import("../views/HomeVisit/HomeVisit.vue"),
      },
      {
        path: "/home-visit-form",
        name: "HomeVisitForm",
        component: () => import("../views/HomeVisit/HomeVisitForm.vue"),
      },
      {
        path: "/appointment-home-visit",
        name: "AppointmentHomeVisit",
        component: () => import("../views/HomeVisit/AppointmentHomeVisit.vue"),
      },
      {
        path: "/table-appointment-home-visit",
        name: "TableAppointmentHomeVisit",
        component: () =>
          import("../views/HomeVisit/TableAppointmentHomeVisit.vue"),
      },
      {
        path: "/home-visit-form",
        name: "HomeVisitForm",
        component: () => import("../views/HomeVisit/HomeVisitForm.vue"),
      },
      // ============================
      {
        path: "/Dashboard-backup",
        name: "dashboard-backup",
        component: () => import("../views/Dashboard-backup.vue"),
      },
      // ===========================
      {
        path: "/report",
        name: "Report",
        component: () => import("../views/Report.vue"),
      },
      {
        path: "/MedicalCertificate",
        name: "medical certificate",
        component: () =>
          import("../views/MedicalCertificate/MedicalCertificate.vue"),
      },
      {
        path: "/doctor-profile",
        name: "doctor-profile",
        component: () => import("../views/DoctorProfile.vue"),
      },
      {
        path: "/checkpoint-counter",
        name: "CheckpointCounter",
        component: () => import("../views/CheckpointCounter.vue"),
      },
    ],
  },
  {
    path: "/dashboardNurse",
    name: "",
    component: () => import("../views/Navbar.vue"),
    children: [
      {
        path: "/",
        name: "DashboardNurse",
        component: () => import("../views/DashboardNurse.vue"),
      },
      {
        path: "/medicalHistory",
        name: "MedicalHistory",
        component: () => import("../views/MedicalHistory.vue"),
      },
      {
        path: "/drug",
        name: "Drug",
        component: () => import("../views/Drug.vue"),
      },
      {
        path: "/druglist",
        name: "DrugList",
        component: () => import("../views/DrugList.vue"),
      },
      {
        path: "/doctorList",
        name: "DoctorList",
        component: () => import("../views/DoctorList.vue"),
      },
      {
        path: "/dashboardNurse/physicalExam",
        name: "PhysicalExam",
        component: () => import("../views/PhysicalExam.vue"),
      },
      {
        path: "/calling-history",
        name: "CallingHistory",
        component: () => import("../views/CallingHistory.vue"),
      },
      {
        path: "/main",
        name: "e-vaccineMain",
        component: () => import("../views/telemed/e-vaccineMain.vue"),
      },
      {
        path: "/calendars",
        name: "Calendars",
        component: () => import("../views/telemed/Calendarst.vue"),
      },
      {
        path: "/payment",
        name: "Payment",
        component: () => import("../views/telemed/Payment.vue"),
      },
      {
        path: "/dashboard-adminTransaction",
        name: "DashboardAdminTransaction",
        component: () => import("../views/DashboardAdminTransition.vue"),
      },
      {
        path: "/dashboard-admin",
        name: "DashboardAdmin",
        component: () => import("../views/DashboardAdmin.vue"),
      },
      {
        path: "/dashboard-adminRegister",
        name: "DashboardRegister",
        component: () => import("../views/DashboardRegister.vue"),
      },
      {
        path: "/fmr",
        name: "fmr",
        component: () => import("../views/Fmr.vue"),
      },
      {
        path: "/iclaim",
        name: "iclaim",
        component: () => import("../views/Iclaim.vue"),
      },
      {
        path: "/cxr",
        name: "cxr",
        component: () => import("../views/Cxr.vue"),
      },
      {
        path: "/contactTele",
        name: "contactadmin",
        component: () => import("../views/contactAdmin.vue"),
      },
      {
        path: "/contactPharma",
        name: "contactPharma",
        component: () => import("../views/contactAdmin.vue"),
      },
      {
        path: "/contactMedcert",
        name: "contactMedcert",
        component: () => import("../views/contactAdmin.vue"),
      },
      {
        path: "/health-check",
        name: "health-check",
        component: () => import("../views/HealthCheck/HealthCheckstatus.vue"),
      },

      {
        path: "/patientsList",
        name: "patientsList",
        component: () =>
          import("../views/Telepharma/PatientsList/PatientsList.vue"),
      },
      {
        path: "/manageClinic",
        name: "manageClinic",
        component: () =>
          import("../views/Telepharma/ManageClinic/ManageClinic.vue"),
      },
      {
        path: "/manageFactory",
        name: "manageFactory",
        component: () =>
          import("../views/Telepharma/ManageFactory/ManageFactory.vue"),
      },
      {
        path: "/manage",
        name: "manage",
        component: () => import("../views/admin/Manage.vue"),
      },
      {
        path: "/register-health-check",
        name: "register-healthCheck",
        component: () => import("../views/HealthCheck/RegisterHealthCheck.vue"),
      },
      {
        path: "/contact",
        name: "contact",
        component: () => import("../views/Contact.vue"),
      },
    ],
  },
  {
    path: "/telepharma",
    name: "telepharma",
    component: () => import("../views/Navbar.vue"),
    children: [
      {
        path: "/PatientsList",
        name: "patients-list",
        component: () =>
          import("../views/Telepharma/PatientsList/PatientsList.vue"),
      },
      {
        path: "/DeliverDrug",
        name: "deliver-drug",
        component: () =>
          import("../views/Telepharma/DeliverDrug/DeliverDrug.vue"),
      },
      {
        path: "/MeetPharmacist",
        name: "MeetPharmacist",
        component: () =>
          import("../views/Telepharma/MeetPharmacist/MeetPharmacist.vue"),
      },
    ],
  },
  {
    path: "/finish-conference",
    name: "FinishConference",
    component: () => import("../views/Telepharma/FinishConference.vue"),
  },
  {
    path: "/management/Telemed/CheckUser",
    name: "TelemedCheckUser",
    component: () => import("../views/bot/Telemed/CheckUser.vue"),
  },
  {
    path: "/management/medcert",
    name: "medcert",
    component: () => import("../views/bot/Telemed/Medcert.vue"),
  },
  {
    path: "/management/noti",
    name: "noti",
    component: () => import("../views/bot/Telemed/Noti.vue"),
  },
  {
    path: "/management/thank-you-payment",
    name: "Thank-you-payment",
    component: () => import("../views/bot/Telemed/ThankyouPayment.vue"),
  },
  {
    path: "/management/test_lineoa",
    name: "TestLineoa",
    component: () => import("../views/bot/Telemed/TestLineoa.vue"),
  },
  {
    path: "/management/telepharma/CheckUser",
    name: "CheckUser",
    component: () => import("../views/bot/Telepharma/CheckUser.vue"),
  },
  {
    path: "/management/telepharma/register",
    name: "Register",
    component: () => import("../views/bot/Telepharma/RegisterMedication.vue"),
  },
  {
    path: "/management/telepharma/RegisterFinish",
    name: "telepharmaRegisterFinish",
    component: () => import("../views/bot/Telepharma/RegisterFinish.vue"),
  },
  {
    path: "/management/telepharma/SatisfactionFrom",
    name: "SatisfactionFrom",
    component: () => import("../views/bot/Telepharma/SatisfactionFrom.vue"),
  },
  {
    path: "/management/telepharma/UpdateLocaions",
    name: "UpdatelocationPharma",
    component: () => import("../views/bot/Telepharma/UpdateLocation.vue"),
  },
  {
    path: "/management/telepharma/Kasemrad_UpdateLocaions",
    name: "UpdatelocationPharmaKasemrad",
    component: () =>
      import("../views/bot/Telepharma/KasemradUpdateLocation.vue"),
  },
  {
    path: "/management/telemed/register",
    name: "RegisterTelemed",
    component: () => import("../views/bot/Telemed/RegisterMedication.vue"),
  },
  {
    path: "/management/telemed/RegisterFinish",
    name: "telemedRegisterFinish",
    component: () => import("../views/bot/Telemed/RegisterFinish.vue"),
  },
  {
    path: "/management/appointment",
    name: "appointment",
    component: () => import("../views/bot/Telemed/Appointment.vue"),
  },
  {
    path: "/management/telemed/create-health-info",
    name: "CreateHealthInfo",
    component: () => import("../views/bot/Telemed/Health_info.vue"),
  },
  {
    path: "/management/select-hospital",
    name: "SelectHospital",
    component: () => import("../views/bot/Telemed/SelectHospital.vue"),
  },
  {
    path: "/management/finish-page",
    name: "FinishPage",
    component: () => import("../views/bot/Telemed/FinishPage.vue"),
  },
  {
    path: "/management/HealthCheck/CheckStaff",
    name: "checkStaffHealthCheck-CheckStaff",
    component: () => import("../views/bot/HealthCheck/CheckStaff.vue"),
  },
  {
    path: "/management/HealthCheck/HealthCheckPoint",
    name: "checkStaffHealthCheck-HealthCheckPoint",
    component: () => import("../views/bot/HealthCheck/HealthCheckPoint.vue"),
  },
  {
    path: "/management/HealthCheck/HealthCheckScanQR",
    name: "checkStaffHealthCheck-HealthCheckScanQR",
    component: () => import("../views/bot/HealthCheck/HealthCheckScanQR.vue"),
  },
  {
    path: "/management/Register/CheckMobileNumber",
    name: "Register-CheckMobileNumber",
    component: () => import("../views/bot/Register/CheckMobileNumber.vue"),
  },
  {
    path: "/management/Register/RegisterWithMobile",
    name: "Register-RegisterWithMobile",
    component: () => import("../views/bot/Register/RegisterWithMobile.vue"),
  },
  {
    path: "/management/branner/noti",
    name: "Branner-Noti",
    component: () => import("../views/bot/Branner/Noti.vue"),
  },
  {
    path: "/branner-noti",
    name: "Branner-Noti-Redirect",
    component: () => import("../views/bot/Branner/Noti.vue"),
  },
  {
    path: "/management/register-line",
    name: "Register-Line",
    component: () => import("../views/LineOA/Register.vue"),
  },
  {
    path: "/management/profile",
    name: "User-Profile",
    component: () => import("../views/LineOA/UserProfile.vue"),
  },
  {
    path: "/management/confirm-otp",
    name: "Confirm-Otp",
    component: () => import("../views/LineOA/ConfirmOtp.vue"),
  },
  {
    path: "/management/medical-history",
    name: "Medical-History",
    component: () => import("../views/LineOA/MedicalHistory.vue"),
  },
  {
    path: "/management/appointment-history",
    name: "Appointment-History",
    component: () => import("../views/LineOA/AppointmentHistory.vue"),
  },
  {
    path: "/management/medical-records",
    name: "Medical-Records",
    component: () => import("../views/LineOA/MedicalRecords.vue"),
  },
  {
    path: "/management/health-information",
    name: "Health-Information",
    component: () => import("../views/LineOA/HealthInformation.vue"),
  },
  {
    path: "/management/health-details",
    name: "Health-Details",
    component: () => import("../views/LineOA/HealthInforDetails.vue"),
  },
  {
    path: "/management/history-medical",
    name: "History-Medical",
    component: () => import("../views/LineOA/HistoryMedical.vue"),
  },
  {
    path: "/management/medical-history-detail",
    name: "History-Detail",
    component: () => import("../views/LineOA/HistoryDetail.vue"),
  },
  // {
  //   path: "/admin",
  //   name: "",
  //   component: () => import("../views/admin/NavbarAdmin.vue"),
  //   children: [
  //     {
  //       path: "/",
  //       name: "dashboard-admin",
  //       component: () => import("../views/admin/DashboardAdmin.vue"),
  //     },
  //     {
  //       path: "/manage",
  //       name: "manage",
  //       component: () => import("../views/admin/Manage.vue"),
  //     }
  //   ],
  // },
  {
    path: "/management",
    name: "Management",
    component: () => import("../views/Navbar.vue"),
    children: [
      {
        path: "/businessManage",
        name: "businessManage",
        component: () => import("../views/BusinessManage.vue"),
      },
      {
        path: "/managePermission",
        name: "managePermission",
        component: () => import("../views/ManagePermission.vue"),
      },
      {
        path: "/ManageClinic",
        name: "manage-clinic",
        component: () =>
          import("../views/Telepharma/ManageClinic/ManageClinic.vue"),
      },
      {
        path: "/manageFactory",
        name: "manage-factory",
        component: () =>
          import("../views/Telepharma/ManageFactory/ManageFactory.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const path = to.path;
  const manage = path.includes("manage");
  const Manage = path.includes("Manage");
  let itemsToken = sessionStorage.access_token
    ? sessionStorage.access_token
    : undefined;
  console.log("path", path);
  if (itemsToken === undefined && !manage && path === "/") {
    next();
  } else if (
    (itemsToken === undefined && (manage || Manage)) ||
    path === "/register"
  ) {
    next();
  } else if (path == "/finish-conference") {
    next();
  } else if (path == "/TEST_page") {
    next();
  } else if (path == "/new-conference") {
    next();
  } else if (path == "/cancel-conference") {
    next();
  } else if (path == "/create-conference") {
    next();
  } else if (path == "/page-authorization-not-found") {
    next();
  } else if (path.includes("/oneid-login")) {
    next();
  } else if (path.includes("/branner-noti")) {
    next();
  } else if (path.includes("/by-pass")) {
    next();
  } else if (itemsToken === undefined) {
    next({ path: "/" });
  } else {
    console.log("path2", path);
    next();
  }
});
export default router;
